import React from 'react';
import {Link, useLocation} from 'react-router-dom';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import UserContext from './usercontext.jsx';
import SvgIcon from '@mui/material/SvgIcon';


function MainMenu() {
    const location = useLocation();
    const pathname = location.pathname;

    return (
        <UserContext.Consumer>
            {user => (
            <MenuList style={{ paddingTop: 0, flex: 1 }}>
                <MenuItem 
                    selected={pathname === '/towers'} 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(206,46,52,0.12)',
                            color: '#C1272D',
                            border: 0,
                            borderRadius: '3px',
                            margin: '5px',
                            '& div': {
                                '& span': {
                                    color: '#C1272D'
                                },
                                '& i': {
                                    color: '#C1272D'
                                },
                                '& svg path': {
                                    fill: '#C1272D'
                                }
                            }
                        }
                    }}
                    component={Link} 
                    to={'/towers'}>
                    <ListItemIcon>
                        <SvgIcon>
                            <path d="M7.56456542,18.3493474 L14.6594165,16.4482877 L9.02619798,14.9388714 L7.56456542,18.3493474 Z M6.56206311,20.6885194 L6,22 L4,22 L10,8 L14,8 L20,22 L18,22 L16.3176504,18.0745177 L6.56206311,20.6885194 L6.56206311,20.6885194 Z M9.82217164,13.0815995 L14.7429023,14.4001053 L12.8571429,10 L11.1428571,10 L9.82217164,13.0815995 L9.82217164,13.0815995 Z M12,2 C13.1045695,2 14,2.8954305 14,4 C14,5.1045695 13.1045695,6 12,6 C10.8954305,6 10,5.1045695 10,4 C10,2.8954305 10.8954305,2 12,2 Z" id="Shape" fill="#000000"/>
                        </SvgIcon>
                    </ListItemIcon>
                    <ListItemText inset primary="Towers" />
                </MenuItem>
                <MenuItem 
                    selected={pathname === '/checklists'} 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(206,46,52,0.12)',
                            color: '#C1272D',
                            border: 0,
                            borderRadius: '3px',
                            margin: '5px',
                            '& div': {
                                '& span': {
                                    color: '#C1272D'
                                },
                                '& i': {
                                    color: '#C1272D'
                                },
                                '& svg path': {
                                    fill: '#C1272D'
                                }
                            }
                        }
                    }}
                    component={Link} 
                    to={'/checklists'}>
                    <ListItemIcon>
                        <i className="material-icons">
                            event_note
                        </i>
                    </ListItemIcon>
                    <ListItemText inset primary="Checklists" />
                </MenuItem>
                <MenuItem 
                    selected={pathname === '/software'} 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(206,46,52,0.12)',
                            color: '#C1272D',
                            border: 0,
                            borderRadius: '3px',
                            margin: '5px',
                            '& div': {
                                '& span': {
                                    color: '#C1272D'
                                },
                                '& i': {
                                    color: '#C1272D'
                                },
                                '& svg path': {
                                    fill: '#C1272D'
                                }
                            }
                        }
                    }}
                    component={Link} 
                    to={'/software'}>
                    <ListItemIcon>
                        <i className="material-icons">
                            update
                        </i>
                    </ListItemIcon>
                    <ListItemText inset primary="Software Versions" />
                </MenuItem>
                <MenuItem 
                    selected={pathname === '/users'} 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(206,46,52,0.12)',
                            color: '#C1272D',
                            border: 0,
                            borderRadius: '3px',
                            margin: '5px',
                            '& div': {
                                '& span': {
                                    color: '#C1272D'
                                },
                                '& i': {
                                    color: '#C1272D'
                                },
                                '& svg path': {
                                    fill: '#C1272D'
                                }
                            }
                        }
                    }}
                    component={Link} 
                    to={'/users'}>
                    <ListItemIcon>
                        <i className="material-icons">
                            face
                        </i>
                    </ListItemIcon>
                    <ListItemText inset primary="Users" />
                </MenuItem>
                <MenuItem 
                    selected={pathname === '/synchronization'} 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        },
                        '&.Mui-selected': {
                            backgroundColor: 'rgba(206,46,52,0.12)',
                            color: '#C1272D',
                            border: 0,
                            borderRadius: '3px',
                            margin: '5px',
                            '& div': {
                                '& span': {
                                    color: '#C1272D'
                                },
                                '& i': {
                                    color: '#C1272D'
                                },
                                '& svg path': {
                                    fill: '#C1272D'
                                }
                            }
                        }
                    }}
                    component={Link} 
                    to={'/synchronization'}>
                    <ListItemIcon>
                        <i className="material-icons">
                            cloud_sync
                        </i>
                    </ListItemIcon>
                    <ListItemText inset primary="Tower synchronization" />
                </MenuItem>
                <div style={{borderTop: '1px solid #dfdfdf'}}/>
                <MenuItem 
                    sx={{
                        margin: '5px',
                        backgroundColor: '#ffffff',
                        '&:hover': {
                            backgroundColor: 'transparent',
                        }
                    }}
                    onClick={user.logout}>
                    <ListItemIcon>
                        <i className="material-icons">
                            exit_to_app
                        </i>
                    </ListItemIcon>
                    <ListItemText inset primary="Sign out" />
                </MenuItem>
            </MenuList>
            )}
        </UserContext.Consumer>
    );
}

export default MainMenu;
